$(document).ready(function () {
    // Customized sub theme
    $('.dynamicPageContainer .sectionHeading').each(function () {
        const text = $(this).text();

        // CUSTOMIZED SUB THEMES
        if (text === '{left}') {
            $(this).parent('.entityContainerRow').addClass('custom-media-module-picture-left-default');
            $(this).css('display', 'none')
        }

        if (text === '{right}') {
            $(this).parent('.entityContainerRow').addClass('custom-media-module-picture-left-default picturerRight');
            $(this).css('display', 'none')
        }
        if (text === '{narrow}') {
            $(this).parent('.entityContainerRow').addClass('customized-pagraph');
            $(this).css('display', 'none')
        }

        // CUSTOMIZED TITLES
        if (text === '{title}') {
            $(this).parent('.entityContainerRow').addClass('customized-title');
            $(this).css('display', 'none')
        }
    })

    // -----------------------------------
    // Customized caption for inner pages
    $('.dynamicPageContainer .moduleItemContainer').each(function () {
        let mediaContainer = $(this).find('.media-container');

        if (mediaContainer.hasClass('single-photo')) {
            let urlCard = $(this).find('a').attr('href');
            let urlCardAttr = $(this).find('a').attr('target');
            let captionContent = $(this).find('.textMediaPhotoCaption span');

            // Pulling img url and caption text - URL > YES | CAPTION > YES
            if (urlCard && urlCard.length >= 1 && captionContent && captionContent.text().length >= 1) {
                let buttonText = captionContent.text();
                let newCaption = $('<a>', { href: urlCard, text: buttonText, class: 'captionWUrl', target: urlCardAttr });
                captionContent.empty().append(newCaption);
            }

            // Pulling img url and creating default caption - URL > YES | CAPTION > NO
            else if (urlCard && urlCard.length >= 1 && captionContent && captionContent.text().length == 0) {
                newCaption = $('<a>', { href: urlCard, text: "Static default Read more", class: 'captionWUrl', target: urlCardAttr });
                mediaContainer.find('.media-text-Container').append(`<div class="textMediaPhotoCaption"></div>`)
                $(this).find('.textMediaPhotoCaption').append(newCaption);
            }
        }
    });
})





$(window).load(function () {
    // Sub Page Label picture
    let labelData = $('.media-container .media-text-Container .textMediaPhotoCaption span').text()
    if (labelData == "") {
        $('.media-container .media-text-Container').addClass('hideComp')
    }
    // EVENTS ICONS
    if ($("body").hasClass("business-id-2")) {
        // $(`<h4>Dine</h4>
        // <h1>food around Fountain Hills</h1>
        // <div class="business-icons">
        // <div class="icon-container1"></div>
        // <div class="icon-container2"></div>
        // <div class="icon-container3"></div>
        // <div class="icon-container4"></div>
        // <div class="icon-container5"></div>
        // <div class="icon-container6"></div>
        // </div>`).appendTo('.textGalleryTextContainer')
        $('.content').before('<div class="bus-banner"></div>')
    }

    if ($("body").hasClass("event-id-0")) {
        $('.content').before('<div class="events-banner"></div>')
    }
})